import React from "react";

import { aboutTitle, aboutData } from "../../data/aboutData";

const About = ({ activeSection }) => {
  return (
    <section id="about">
      <h3 className={activeSection === "about" ? "active" : ""}>{aboutTitle}</h3>
      <p>{aboutData}</p>
    </section>
  );
};

export default About;
